/**
 * @Author: 左建
 * @Date: 2022/8/30 10:49
 * @LastEditTime: 2022/8/30 10:49
 * @Description: 操作日志相关
*/

// 获取搜索表单默认值
export function getIntiSearchForm (params) {
    return {
        Type: undefined, // 课程状态
        keyWord: undefined // 课程名称
    }
}
// 操作类型
export const OPTIONS_TYPE = Object.freeze({
    0: "试题",
    1: "试卷",
    2: "用户导入",
    3: "用户组导入"
})
